<template>
    <article :class="[`alert ${alertType}`, { 'alert--slim' : slim }]">
        <h3 class="alert__title" v-if="!hideTitle">{{ alertTitle }}</h3>
        <slot></slot>
    </article>
</template>

<script>
export default {
    props: {
        slim: {
            type: Boolean,
            default: true
        },

        type: {
            type: String,
            validator: function (value) {
                return ['info', 'warning', 'danger', 'error', 'success'].indexOf(value) !== -1
            },
            default: 'info'
        },

        title: {
            type: String
        },

        hideTitle: {
            type: Boolean,
            default: false
        }
    },

    computed: {
        alertType () {
            const { type } = this.$props

            switch (type) {
                case 'info': return 'alert--info'
                case 'warning': return 'alert--warning'
                case 'danger': return 'alert--error'
                case 'error': return 'alert--error'
                case 'success': return 'alert--success'
                default: return 'alert--info'
            }
        },

        alertTitle () {
            const { type } = this.$props

            if (!this.title) {
                switch (type) {
                    case 'info': return 'Note'
                    case 'warning': return 'Warning'
                    case 'danger': return 'Error'
                    case 'error': return 'Error'
                    case 'success': return 'Success'
                    default: return 'Note'
                }
            }

            return this.title
        }
    }
}
</script>
